<template>
    <img src="../../../public/images/bigLogo.dce08a05.png" alt="">
</template>


